import React from "react";
import { AvatarWithName } from "@/shared/ui/Avatar";
import { Column } from "@/shared/ui/Blocks";

interface TourStepProps {
  title?: string;
  text?: string;
  image?: string;
}

export default function ({ title, text, image }: TourStepProps) {
  return (
    <Column>
      <AvatarWithName name="Alo from Wisnio" avatar="/images/alo.png" />
      {title && <h4>{title}</h4>}
      {text && <p>{text}</p>}
      {image && <div className="w-full my-8">{image}</div>}
    </Column>
  );
}
